var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCleanDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "32px",
    height: "32px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.01855,50.37549A250.08793,250.08793,0,0,0,130.294,12.72314a4.00112,4.00112,0,0,0-4.5879,0,250.08793,250.08793,0,0,0-40.7246,37.65235C58.17139,81.207,44,113.582,44,144a84,84,0,0,0,168,0C212,113.582,197.82861,81.207,171.01855,50.37549ZM128,220a76.08582,76.08582,0,0,1-76-76c0-35.89648,21.15186-67.79541,38.896-88.23486A254.05123,254.05123,0,0,1,128,20.96484a254.05123,254.05123,0,0,1,37.104,34.8003C182.84814,76.20459,204,108.10352,204,144A76.08582,76.08582,0,0,1,128,220Zm51.26855-67.272a51.84932,51.84932,0,0,1-42.48535,42.43261,4.04419,4.04419,0,0,1-.66845.05567,4.00038,4.00038,0,0,1-.6587-7.94531,43.84146,43.84146,0,0,0,35.92481-35.87989,4.00009,4.00009,0,1,1,7.88769,1.33692Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanDrop);
export default __webpack_public_path__ + "static/media/clean_drop.8fcfe80ba4c82c88cd7b59bb51b87245.svg";
export { ForwardRef as ReactComponent };